import { render, staticRenderFns } from "./ProductFeeConfigList.vue?vue&type=template&id=817ccbf2&scoped=true"
import script from "./ProductFeeConfigList.vue?vue&type=script&lang=js"
export * from "./ProductFeeConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817ccbf2",
  null
  
)

export default component.exports